var rtl_default = {
  "rtl": "knXtC",
  "ltr": "EMX6Q"
};
export {
  rtl_default as default
};
//# sourceMappingURL=rtl-scss.js.map
